<template>
  <div>
    <div id="chart">
      <apexchart type="area" height="350" :options="chartOptions" :series="series" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["labels", "identificados", "naoidentificados", "fidelizados"],
  async mounted() {
    var identificadosTratado = await this.generateTimestampData(
      this.labels,
      this.identificados
    );
    var naoidentificadosTratado = await this.generateTimestampData(
      this.labels,
      this.naoidentificados
    );
    var fidelizadosTratado = await this.generateTimestampData(
      this.labels,
      this.fidelizados
    );
    this.series = [
      {
        name: "Fidelizados",
        data: fidelizadosTratado
      },
      {
        name: "Identificados",
        data: identificadosTratado
      },
      {
        name: "Não identificados",
        data: naoidentificadosTratado
      }
    ];
    console.info(this.series);
  },
  data: _ => {
    return {
      series: [],
      chartOptions: {
        markers: {
          size: 3
        },
        height: 350,
        type: "area",
        events: {
          selection: function(chart, e) {
            console.log(new Date(e.xaxis.min));
          }
        },
        colors: ["#f5d142", "#008FFB", "#00E396"],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "left"
        },
        xaxis: {
          type: "datetime",
          labels: {
            formatter: function(value, timestamp) {
              return moment(timestamp).format("DD/MM"); // The formatter function overrides format property
            }
          }
        }
      }
    };
  },
  methods: {
    generateDayWiseTimeSeries(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = baseval;
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;

        series.push([x, y]);
        baseval += 86400000;
        i++;
      }
      return series;
    },
    generateTimestampData(labels, array) {
      var arr = [];
      for (let i = 0; i < labels.length; i++) {
        const e = labels[i];
        let dataCortada = e.split("/");
        let data = moment(
          `${dataCortada[2]}-${dataCortada[1]}-${dataCortada[0]}`
        );
        arr.push([new Date(data).getTime(), array[i]]);
      }
      return arr;
    }
  }
};
</script>
